import React, { useContext } from 'react';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { ROUTES } from 'routes/data';
import { useLocation, matchPath } from 'react-router-dom';
import { translateRole } from 'utils/translateRole';
import { globalContext } from 'context/global';
import { Wrapper, HomeIcon, ArrowIcon, ButtonStep } from './styles';

export interface BreadcrumbProps {
  color?: 'light' | 'standard';
  claimNumber?: string;
}

export const Breadcrumb = ({
  color = 'standard',
  claimNumber,
}: BreadcrumbProps): JSX.Element => {
  const history = useHistoryWithHost();
  const location = useLocation();
  const { containerContext } = useContext(globalContext);
  const { user } = containerContext;
  const navigateToRoute = (toPath: string) => {
    history.push(toPath);
  };
  const cleanedPathname = location.pathname.replace(
    '/mf/seguros-financeiro',
    '',
  );

  const steps = ROUTES.filter(({ path: routePath }) =>
    matchPath({ path: routePath, end: false }, cleanedPathname),
  ).filter(({ roles }) =>
    roles.some(role => role === translateRole(user.role)),
  );
  return (
    <Wrapper color={color}>
      {steps.map((step, index) =>
        step.path === '/' ? (
          <HomeIcon
            onClick={() => navigateToRoute(step.path)}
            onKeyDown={() => navigateToRoute(step.path)}
            tabIndex={0}
            key="home"
          />
        ) : (
          <React.Fragment key={step.path}>
            {index !== 1 && <ArrowIcon />}
            <ButtonStep
              islast={steps.length - 1 === index ? 'yes' : 'no'}
              onClick={() => navigateToRoute(step.path)}
            >
              {step?.name?.includes('Sinistro #') && !!claimNumber
                ? step.name + claimNumber
                : step.name}
            </ButtonStep>
          </React.Fragment>
        ),
      )}
    </Wrapper>
  );
};
